import React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

export default createSvgIcon(React.createElement(
  'g',
  null,
  React.createElement('rect', { x: '9.84', y: '15.35', width: '12.32', height: '1.3' })
));